import { CardActionsProps, CardActions as MuiCardActions } from "@mui/material";

type Props = CardActionsProps;

export const CardActions = ({ children, ...props }: Props) => {
  return <MuiCardActions {...props}>{children}</MuiCardActions>;
};
